import { lazy } from 'react';

export const SuccessAsync = lazy(() => import('./Success').then((m) => ({ default: m.Success })));
